import { isEmpty } from "lodash";

const TemplateBox = ({ selectedDataElement, jsonPath, csvPath }) => {
	const documentName = selectedDataElement?.name || "Data Element Name";

	if (isEmpty(selectedDataElement)) {
		return null;
	}

	return (
		<div className="template-box__sharedData">
			<div className="template-box__header">
				<div className="template-box__header__right">
					<div className="template-box__header__title">
						Download Templates
					</div>
				</div>
			</div>
			<div className="template-box__content">
				Here are the templates you can use as reference for <b>{documentName}</b><br />
				Please click and download <a href={jsonPath} download={`json_template_${selectedDataElement.id}.json`}>JSON Template</a> or <a href={csvPath} download={`csv_template_${selectedDataElement.id}.csv`}>CSV Template</a>.
			</div>
		</div>
	);
};

export default TemplateBox;
